import { z } from "zod";
import { collectNodeDateFieldSchema } from "./date-field.schema";
import { collectNodeEmailFieldSchema } from "./email-field.schema";
import { collectNodeFileFieldSchema } from "./file-field.schema";
import { collectNodeNumberFieldSchema } from "./number-field.schema";
import { collectNodePhoneFieldSchema } from "./phone-field.schema";
import { collectNodeTextFieldSchema } from "./text-field.schema";
import { collectNodeTimeFieldSchema } from "./time-field.schema";
import { collectNodeLocationFieldSchema } from "./location-field.schema";
import { collectNodeCategoryFieldSchema } from "./category-field.schema";
import { messageNodeFieldSchema } from "../../message-node/fields";
import { collectNodeSelectFieldSchema } from "./select-field.schema";
import { collectNodeConsentFormSchema } from "./consent-field.schema";
const collectNodeCommonFieldSchema = z.object({
  slot_name: z.string().optional(), // -> required for ai backend (not filled from frontend, kept for web widget. Do not remove)
  name: z
    .string()
    .min(1, "Please enter valid name")
    .max(45, "Name should be precise and less than 45 characters")
    .regex(
      /^[a-zA-Z0-9_ -]*$/,
      "Name can only contain alphanumeric characters, `-` and `_`",
    ),
  description: z.string().default("").optional(),
  mandatoryField: z.boolean().default(false).optional(),
  mappedUserProfile: z
    .object({
      id: z.string(),
      label: z.string(),
    })
    .optional(),
  messageFields: z.array(messageNodeFieldSchema).optional(),
});

export const collectNodeCombinedFieldsSchema = z.union([
  collectNodeDateFieldSchema,
  collectNodeEmailFieldSchema,
  collectNodeFileFieldSchema,
  collectNodeNumberFieldSchema,
  collectNodePhoneFieldSchema,
  collectNodeTextFieldSchema,
  collectNodeTimeFieldSchema,
  collectNodeLocationFieldSchema,
  collectNodeCategoryFieldSchema,
  collectNodeSelectFieldSchema,
  collectNodeConsentFormSchema,
]);

export const collectNodeFieldSchema = z.intersection(
  collectNodeCombinedFieldsSchema,
  collectNodeCommonFieldSchema,
);

export type CollectNodeFieldSchema = z.infer<typeof collectNodeFieldSchema>;
